import { gql } from '@apollo/client';
import { booking, leg, passenger, product } from 'store/queries/GET_BOOKING';
import { insuranceFragment, hotelFragment } from 'store/fragments';

export default gql`
  mutation createBooking(
    $segments: [InputSegment]
    $passengers: [InputPassenger]
    $customer: CustomerInput
    $fulfillmentMethodCode: FulfillmentMethodEnum
    $currency: String
    $contractCode: String
    $language: Language
    $additionalDetails: [InputAdditionalDetails]
  ) {
    createBooking(
      currency: $currency
      segments: $segments
      passengers: $passengers
      customer: $customer
      fulfillmentMethodCode: $fulfillmentMethodCode
      contractCode: $contractCode
      language: $language
      additionalDetails: $additionalDetails
    ) {
      ${booking}
    }
  }
  
  ${insuranceFragment}
  
  ${hotelFragment}
  
  ${leg}
  
  ${passenger}
  
  ${product}
`;
